/**
 * Maps a Composer-era FindingLocation onto a Workshop DOM anchor.
 *
 * The wiring findings still use the Composer's card vocabulary
 * (`bundle|identity|skills|tools|workflows`), but the Workshop has
 * sections, not cards — which is why `handleJump` was a documented
 * no-op. Rather than restructure the finding type, we translate.
 *
 * Returns null for anything unrecognised: a jump that lands somewhere
 * arbitrary is worse than a jump that doesn't happen.
 */
import type { FindingLocation } from '@/utils/bundleFindings'

export function workshopAnchorId(loc: FindingLocation): string | null {
  switch (loc.card) {
    case 'skills':
    case 'tools':
    case 'workflows':
      return 'workshop-capabilities'
    case 'identity':
      return 'workshop-identity'
    case 'bundle':
      return 'workshop-top'
    default:
      return null
  }
}
